/**
 * Render a customer's display label for picker/combobox options.
 *
 * EP-56 K4 — every customer picker used to render `${c.name} (${c.phone})`
 * with no null guard. When phone was null/empty, the label leaked as
 * `"Test Tenant (null)"` or `"Test Tenant ()"`. `null` on a money-adjacent
 * screen costs trust disproportionately, so guard at the helper layer.
 *
 * Returns:
 *   - `"Name (Phone)"` when phone is a non-empty string after trim
 *   - `"Name"`         when phone is null, undefined, empty string, or whitespace
 */
export function customerLabel(c: {
  name: string
  phone?: string | null
}): string {
  const phone = c.phone?.trim()
  if (phone) return `${c.name} (${phone})`
  return c.name
}
